<!--<h2>{{cardConfiguration.title}}</h2>-->
  <ng-container *ngIf="isVersion2()">
    <h2>Notificações</h2>


    <div class="row">
      <div class="col-sm-8">
        <div class="form-group">
          <label for="email" class="disabled">
            {{'CardCommunicationDetails.TextEmail' | translate}}
            <i>{{'CardCommunicationDetails.Email' | translate}}</i>
            <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip='O e-mail é pré-preenchido com a informação registada na CGA Directa. Caso esteja desatualizado, altere-o na CGA Directa, no menu "Ficha utilizador".'></span>
          </label>
          <input id="text" class="form-control" readonly placeholder="{{'CardCommunicationDetails.EmailEx' | translate}}" [(ngModel)]="cardData.email" name="email"
                 #email="ngModel">
          <validation-message [control]="email"></validation-message>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-sm-8">
        <div class="form-group">
          <label for="email" class="disabled">{{'CardCommunicationDetails.TextEmailService' | translate}}
            <i>{{'CardCommunicationDetails.Email' | translate}}</i>
            <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip='Informação disponível na CGA Directa, no menu Subscrições. Pedidos de alteração devem ser submetidos por e-mail com o assunto “atualização dados entidades".'></span>
          </label>
          <input id="text" class="form-control" readonly placeholder="{{'CardCommunicationDetails.EmailEx' | translate}}" [(ngModel)]="cardData.emailService" name="emailService"
                 #emailService="ngModel">
          <validation-message [control]="email"></validation-message>
        </div>
      </div>
    </div>

  </ng-container>

<ng-container *ngIf="!isVersion2()">
  <h2>Notificações</h2>

  <div class="row" *ngIf="!isWorkflowIncapacity && (isWorkflowOnSubscriber || isWorkflowPgpv)">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="PrevComunicationValue">
          <span class="mandatory">*</span>{{'CardCommunicationDetails.PrevComunicationValue' | translate}}
          <button type="button"
                  class="btn-icon text-primary icon-help"
                  aria-label="Tooltip com informação"
                  tooltip="{{'Tooltips.CardCommunicationDetails.PrevComunicationValue' | translate}}"></button>
        </label>
        <div class="btn-group btn-group-toggle">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.prevComunicationValue" [radioLabel]="prevComunicationValue">
            <input type="radio" [(ngModel)]="cardData.prevComunicationValue" name="prevComunicationValue" #prevComunicationValue="ngModel" [value]="domain.value" required
                    [clearRelated]="{model : this.cardData , propsToReset : ['reflectionDeadlineCode']}" (ngModelChange)="onPrevComChanged($event)">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="ReflectionDeadline" [class.disabled]="cardData.prevComunicationValue?.toString() != 'true'">
          <span class="mandatory" *ngIf="cardData.prevComunicationValue && cardData.prevComunicationValue?.toString() == 'true'">*</span>
          {{'CardCommunicationDetails.ReflectionDeadline' | translate}}
          <button type="button"
                  class="btn-icon text-primary icon-help"
                  aria-label="Tooltip com informação"
                  tooltip="{{'Tooltips.CardCommunicationDetails.ReflectionDeadline' | translate}}"></button>
        </label>
        <select class="custom-select" [(ngModel)]="cardData.reflectionDeadlineCode" name="reflectionDeadlineCode" #reflectionDeadlineCode="ngModel"
                [required]="cardData.prevComunicationValue && cardData.prevComunicationValue?.toString() == 'true'"
                [disabled]="cardData.prevComunicationValue?.toString() != 'true'"
                [dropdownTitle]="{value : cardData.reflectionDeadlineCode , dimensions : reflectionDeadlines }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getOrderReflectionDeadlines()" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="reflectionDeadlineCode"></validation-message>
      </div>

    </div>
  </div>


  <div class="row">
    <div class="col-sm-8">
      <div class="form-group">
        <label for="email" class="disabled">{{'CardCommunicationDetails.TextEmail' | translate}} <i>{{'CardCommunicationDetails.Email' | translate}}</i></label>
        <input id="text" class="form-control" readonly placeholder="{{'CardCommunicationDetails.EmailEx' | translate}}" [(ngModel)]="cardData.email" name="email"
                #email="ngModel">
        <validation-message [control]="email"></validation-message>
      </div>
    </div>
  </div>


  <div class="row">
    <div class="col-sm-8">
      <div class="form-group">
        <label for="email" class="disabled">{{'CardCommunicationDetails.TextEmailService' | translate}} <i>{{'CardCommunicationDetails.Email' | translate}}</i></label>
        <input id="text" class="form-control" readonly placeholder="{{'CardCommunicationDetails.EmailEx' | translate}}" [(ngModel)]="cardData.emailService" name="emailService"
                #emailService="ngModel">
        <validation-message [control]="email"></validation-message>
      </div>
    </div>
  </div>
</ng-container>
<!--<pre>{{cardData | json}}</pre>-->
